'use client';
/** @jsxImportSource @emotion/react */

import type { TableBodyProps as MuiTableBodyProps } from '@mui/material/TableBody';

import MuiTableBody from '@mui/material/TableBody';

type ExcludedMuiProps = '';

interface TableBodyProps extends Omit<MuiTableBodyProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { TableBodyProps };
export const TableBody: React.FC<TableBodyProps> = MuiTableBody;

TableBody.displayName = 'TableBody';
